module.exports = __webpack_public_path__ + "static/media/lohi-dark.a94d4110.svg";